// @flow

const initialState = {
  key: '',
  name: '',
  type: 'string'
};

export default initialState;